import client from '/src/services/client.js';

export default {
    getColumns: (id, data) => client.get(`dataset/${id}/worksheet/columns`, data),
    addColumn: (id, data) => client.post(`dataset/${id}/worksheet/column`, data),
    updateColumn: (id, data) => client.put(`dataset/${id}/worksheet/column`, data),
    deleteColumn: (id, data) => client.delete(`dataset/${id}/worksheet/column`, data),

    getRegex : (data) => client.get(`dataset/worksheets/regex`,data)
}